import React, { Component } from 'react'
import _ from 'lodash'
import ReactLoading from 'react-loading'
import * as StyledComponent from '../styles'

class AddToBagBtn extends Component {
  state = {
    active: ''
  }

  pressbutton = () => {
    // skip when button is disabled or already active
    if (this.props.disabled || !_.isEmpty(this.state.active)) return

    const { addToBag } = this.props
    this.setState({ active: 'active' }, () =>
      setTimeout(() => this.setState({ active: '' }), 200)
    )
    !this.state.loading && _.isFunction(addToBag) && addToBag()
  }

  render() {
    const disabled = this.props.disabled || !_.isEmpty(this.state.active) ? true : false
    return <StyledComponent.AddToBagBtn
      className={`add-to-bag ${this.state.active}`}
      disabled={disabled}
      onClick={this.pressbutton}
    >
      {
        this.props.loading && this.props.product_id === this.props.loading_id
          ? <ReactLoading type='spokes' color='#444' height={30} width={30} delay={0} className='add-to-cart-loading' />
          : this.props.text
      }
    </StyledComponent.AddToBagBtn>
  }
}

AddToBagBtn.defaultProps = {
  add_to_cart_label_class: 'normal',
  loading: false,
  disabled: false,
  text: '',
  addToBag: () => {}
}

export default AddToBagBtn



// WEBPACK FOOTER //
// ./src/components/AddToBagBtn.js